import camelize from 'camelcase-keys-deep';

export default class Template {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  auctionCategory() {
    return this.env().AuctionCategory.getById(this.auctionCategoryId);
  }
}
